module.exports = __webpack_public_path__ + "img/logo.979af1f7.png";